import { Text } from '@chakra-ui/react';
import { MessageDividerWrapper } from './divider-wrapper';

export type MessageDividerDateProps = {
  children: React.ReactNode;
};

export const MessageDividerDate = memo(function MessageDividerDate({
  children,
}: MessageDividerDateProps) {
  return (
    <MessageDividerWrapper className="MessageDividerDate">
      <Text
        p="6px 12px"
        borderRadius="full"
        backdropFilter="blur(3px)"
        shadow="0 0 24px 0 rgba(0, 0, 0, 0.06)"
        fontSize="sm"
        fontWeight="medium"
      >
        {children}
      </Text>
    </MessageDividerWrapper>
  );
});
